import React, { useEffect, useRef } from 'react';
import { Info } from 'lucide-react';
import { useSiteNotice } from '@/contexts/SiteNoticeContext';

// Schmaler, temporärer Hinweis-Streifen ganz oben im Header (über der Navy-Leiste).
// Meldet seine tatsächliche Höhe an den Context, damit der Seiteninhalt korrekt nachrückt.
const SiteNoticeBar = () => {
  const { active, text, setBarHeight } = useSiteNotice();
  const ref = useRef(null);

  useEffect(() => {
    if (!active || !text || !ref.current) {
      setBarHeight(0);
      return undefined;
    }
    const el = ref.current;
    const update = () => setBarHeight(el.offsetHeight);
    update();
    const ro = new ResizeObserver(update);
    ro.observe(el);
    return () => {
      ro.disconnect();
      setBarHeight(0);
    };
  }, [active, text, setBarHeight]);

  if (!active || !text) return null;

  return (
    <div ref={ref} data-testid="site-notice-bar" className="bg-brand-gold text-brand-navy">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-1.5 flex items-center justify-center gap-2 text-center">
        <Info className="w-4 h-4 flex-shrink-0" />
        <p className="text-[12px] sm:text-[13px] font-semibold leading-snug" data-testid="site-notice-text">
          {text}
        </p>
      </div>
    </div>
  );
};

export default SiteNoticeBar;
